import { Alert, AppBar, Backdrop, Box, Button, ButtonGroup, CircularProgress, ImageListItem, Modal, Paper, Snackbar, Stack, Toolbar, Tooltip, Typography } from "@mui/material";
import { LoadState, getBackendImagesUrl, getBackendUrl } from "../../../redux/common";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ImageInfo } from "../../../redux/image/imageSlice";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { imageSetAvatarThunk, ImageSetAvatarRequest, imageSetAvatarSlice } from "../../../redux/image/imageSetAvatar";
import { faceDetailsListSlice, retrieveFaceDetailsList } from "../../../redux/face/faceDetailsListSlice";
import { faceDisplayname } from "../../../redux/face/faceDetailsSlice";
import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { imageDelete } from '../../../redux/image/imageSlice';
import { ModalImageDetailMgmt } from "./ModalImageDetailMgmt";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

export interface Buttons {
    label: React.ReactNode;
    click: () => void;
}
  
export interface ModalImageDetailProps {
    avatar?: ImageSetAvatarRequest;
    open: boolean;
    close: () => void;
    previous?: () => void;
    next?: () => void;
    image: ImageInfo | undefined;
    schoolId?: string;
    canDelete?: boolean;
}
export function ModalImageDetail(props: ModalImageDetailProps) {
        const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
        const [deleting, setDeleting] = useState(false);
        const [deleteError, setDeleteError] = useState<string|null>(null);
    const dispatch = useAppDispatch();
    const imageSetAvatar = useAppSelector(state => state.imageSetAvatar);
    const faces = useAppSelector(state => state.faceDetailsList);
    const [selectedFace, setSelectedFace] = useState(-1);

    if(props.image == undefined) {
        return <></>;
    }

    dispatch(faceDetailsListSlice.actions.check({ imageId: props.image?.id || "" }));
    if(faces.state.state == LoadState.NotStarted) {
        dispatch(retrieveFaceDetailsList({ imageId: props.image?.id || "" }));
    }

    const formatDate = (date: string | undefined) => {
        const options: Intl.DateTimeFormatOptions = { weekday: "short", year: "numeric", month: "short", day: "2-digit" };
        return new Date(date || "2000-01-01" ).toLocaleDateString(undefined, options);
    };

    const handleDeleteClick = () => {
        setOpenDeleteDialog(true);
    };

    const handleDeleteCancel = () => {
        setOpenDeleteDialog(false);
        setDeleteError(null);
    };

    const handleDeleteConfirm = async () => {
        setDeleting(true);
        setDeleteError(null);
        try {
            if (!props.image?.id) {
                setDeleteError("ID da imagem não encontrado.");
                setDeleting(false);
                return;
            }
            await dispatch(imageDelete({ imageId: props.image.id }));
            setOpenDeleteDialog(false);
            setDeleting(false);
            props.close();
        } catch (err: any) {
            setDeleteError("Erro ao remover imagem. Tente novamente.");
            setDeleting(false);
        }
    };

    const elToolbar = <AppBar position="static" color={"primary"} sx={{ }}>
        <Toolbar sx={{ height: {xs: 30} }}>
            <Typography variant="overline" component="div" sx={{ flexGrow: 1 }}> {`${formatDate(props.image?.createdAt)}`} </Typography>
            <Box sx={{ flexGrow: 1 }} />
                <ButtonGroup variant="contained" color="secondary" size="small">
                    {
                        props.canDelete
                        ?   <Tooltip title="Excluir imagem" >
                                <Button key="delete" 
                                    color="error"
                                    onClick={handleDeleteClick}>
                                    <DeleteForeverIcon />
                                </Button>
                            </Tooltip>
                        :   <></>
                    }
                    {
                        props.avatar
                        ?   <Tooltip title="Definir como avatar" >
                                <Button key="avatar" 
                                    onClick={() => { 
                                        if(props.avatar) {
                                            dispatch(imageSetAvatarThunk(props.avatar));
                                        }
                                    }}>
                                    <AccountCircleIcon/>
                                </Button>
                            </Tooltip>
                        :   <></>
                    }
                    <Tooltip title="Fechar" >
                        <Button key="close" onClick={() => { props.close(); }}><CloseIcon /></Button>
                    </Tooltip>
                </ButtonGroup>
        </Toolbar>
    </AppBar>;

    const landscape = window.innerHeight < window.innerWidth;

    const faceSize = 40;
    const facesHeight = ((! faces.list) || faces.list.length == 0) ? 0 : faceSize+25;
    const modalMargin = 10;
    
    const buttonWidth = 40;

    const pictHeigth = landscape 
    ? window.innerHeight - ( 80 + facesHeight )
    : window.innerHeight - ( 80 + facesHeight + buttonWidth )
    ;
    const pictWidth = landscape
    ? window.innerWidth - (buttonWidth*2 + modalMargin*2)
    : window.innerWidth - (modalMargin*2)
    ;


    const url = getBackendImagesUrl(props.image);
    const content = () => {
        return <Box>
            <Stack direction={ landscape ? "row" : "column" } width="100%">
                <Stack sx={{display: !landscape ? "block" : "none"}} direction="row" width="100%">
                    <Button sx={{width: "50%", minWidth: "50%"}} variant="outlined" color="primary" onClick={() => props.previous ? props.previous() : {}} disabled={props.previous ? false : true}><ArrowBackIosNewIcon/></Button>
                    <Button sx={{width: "50%", minWidth: "50%"}} variant="outlined" color="primary" onClick={() => props.next ? props.next() : {}} disabled={props.next ? false : true}><ArrowForwardIosIcon/></Button>
                </Stack>
                <Button sx={{width: buttonWidth, minWidth: buttonWidth, display: landscape ? "block" : "none"}} onClick={() => props.previous ? props.previous() : {}} disabled={props.previous ? false : true}><ArrowBackIosNewIcon/></Button>
                <Box
                    component="img"
                    style={{  }}
                    // sx={{ height: window.innerHeight * multiplier, width: window.innerWidth * multiplier, objectFit: "contain" }}
                    sx={{ height: pictHeigth, width: pictWidth, objectFit: "contain" }}
                    alt={`${props.image?.id } - ${formatDate(props.image?.createdAt)}`}
                    src={url} />
                <Button sx={{width: buttonWidth, minWidth: buttonWidth, display: landscape ? "block" : "none"}} onClick={() => props.next ? props.next() : {}} disabled={props.next ? false : true}><ArrowForwardIosIcon/></Button>
            </Stack>
        </Box>;
    };

    const elFaces = () => {
        if((! faces.list) || faces.list.length == 0)
            return <></>;

        const size = faceSize;
        const list = faces.list;
        const imagesEl = [] as React.ReactNode[];
        for(let i = 0; i < faces.list.length; i++) {
            const item = list[i];
            imagesEl.push(
                <Tooltip key={item.photoFace.id} title={faceDisplayname(item)} >
                    <ImageListItem key={item.photoFace.id} sx={{width: size, height: size, m: "5px", mb: 0}} style={{height: size, width: size}}>
                        <img 
                            src={`${getBackendUrl()}/api/face/${item.photoFace.id}`} 
                            alt={item.photoFace.id} 
                            width={size} height={size} 
                            onClick={() => setSelectedFace(i)} />
                    </ImageListItem>
                </Tooltip>
            );
        }

        return <Box sx={{overflowX: "scroll", height: facesHeight, mx: 1}}>
                <Stack direction="row" width="fit-content">
                    {imagesEl}
                </Stack>
            </Box>;
    };

    const dismissImageSetSnack = () => {
        dispatch(imageSetAvatarSlice.actions.clean());
    };

    return <>
        <Dialog open={openDeleteDialog} onClose={handleDeleteCancel} aria-labelledby="delete-image-dialog-title">
            <DialogTitle id="delete-image-dialog-title">Remover Imagem</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Esta ação é <b>irreversível</b> e todos os dados associados serão perdidos!
                </DialogContentText>
                <DialogContentText sx={{ color: 'error.main' }}>
                    Tem certeza que deseja <b>REMOVER</b> esta imagem?
                </DialogContentText>
                {deleteError && <DialogContentText color="error">{deleteError}</DialogContentText>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDeleteCancel} color="primary" variant="contained" disabled={deleting}>Cancelar</Button>
                <Button onClick={handleDeleteConfirm} color="error" variant="contained" disabled={deleting} autoFocus>
                    {deleting ? "Removendo..." : "Remover"}
                </Button>
            </DialogActions>
        </Dialog>
        <Modal open={props.open} onClose={() => props.close()} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Paper sx={{ width: window.innerWidth, m: `${modalMargin}px`, minWidth: "300px" }} elevation={3}>
                {elToolbar}
                <Box display={"block"} width="100%">
                    {content()}
                </Box>
                <Box display={"block"} width="100%">
                    {elFaces()}
                </Box>
                <Backdrop open={imageSetAvatar.state.state == LoadState.Loading} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={imageSetAvatar.state.state == LoadState.Failed} autoHideDuration={1000} onClose={dismissImageSetSnack}>
                    <Alert onClose={dismissImageSetSnack} severity="error" variant="filled" sx={{ width: "100%" }}> Erro ao atualizar avatar. </Alert>
                </Snackbar>
                <ModalImageDetailMgmt 
                    open={selectedFace >= 0} 
                    close={() => setSelectedFace(-1)} 
                    image={selectedFace >= 0 && faces?.list ? faces.list[selectedFace] : undefined}
                    next={ (faces.list && selectedFace < faces.list.length - 1) ? () => setSelectedFace(selectedFace + 1) : undefined }
                    previous={ selectedFace > 0 ? () => setSelectedFace(selectedFace - 1) : undefined }
                    schoolId={props.schoolId}
                />
            </Paper>
        </Modal>
    </>;
}
